export const blockIconsMapsPersonPin = (
	<span className='material-symbols-outlined'>person_pin</span>
);
